import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from 'src/app/auth';
import {FormBuilder, Validators} from '@angular/forms';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import set = Reflect.set;

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent  implements OnInit {
  disabled = false;
  message;
  css: any;
  form = this.fb.group({
    username: '',
    password: '',
  });

  form2 = this.fb.group({
    username: '',
    password: '',
  });
  linkToken;
  validUsername = false;
  validPassword = false;

  isVisible = false;
  isVisible2 = false;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
  ) {
  }

  ngOnInit() {
    // redirect to home if already logged in
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    const user = this.authService.currentUserValue;
    if (user) {
      this.router.navigate(['/business/dashboard']);
    }

    if (sessionStorage.getItem('showBannerLogin') !== 'true') {
      this.isVisible2 = true;
    }
    sessionStorage.setItem('showBannerLogin', 'true');
  }

  handleCancel2(): void {
    this.isVisible2 = false;
  }

  inputChange(event, input) {
    if (event.length) {
      this[input] = true;
    } else {
      this[input] = false;
    }
  }

  handleCancel(): void {
    this.isVisible = false;
  }


  onSubmit() {

    const phone = this.form2.get('username').value;
    const password = this.form2.get('password').value;
    const body = {
      phone: phone.trim(),
      password: password.trim()
    };
    this.authService.linkAcc(this.linkToken, body).subscribe((res) => {
      if (res.code === 1) {
        this.notification.create(
          'success',
          'Thành công',
          'Mời bạn đăng nhập bằng tài khoản vừa liên kết',
          {nzDuration: 600000}
        );
        this.isVisible = false;
      } else {
        this.notification.create(
          'error',
          'Thất bại',
          res.message
        );

      }
    }, err => {
      this.notification.create(
        'error',
        'Thất bại',
        err
      );
    });


  }

  disabledMess() {

    $('.ant-notification-notice-close-x').click();
  }

  login() {
    this.message = '';
    let phone = this.form.get('username').value;
    let password = this.form.get('password').value;
    if (!phone || !password) {
      return;
    }
    if (phone && password) {
      this.disabled = true;
      phone = phone.trim();
      password = password.trim();
      const body = {
        username: phone,
        password
      };

      this.authService.login(body).subscribe(response => {

          this.disabled = false;
          if (response.code === 1) {
            this.css = {
              'margin-top': '5px',
              color: '#01DF01',
              'font-weight': 500,
              'font-size': '13px',
            };
            this.message = 'Đăng nhập thành công!';
            setTimeout(() => {
              if (response.isAdmin === true) {
                this.router.navigate(['/support-business']);
              } else {
                this.router.navigate(['/business/dashboard']);
              }
            }, 1000);
            return;
          } else if (response.code === 1026) {
            this.isVisible = true;
            this.linkToken = response.token_link;
          } else {
            this.css = {
              'margin-top': '5px',
              color: 'red',
              'font-weight': 500,
              'font-size': '13px',
            };
            this.message = response.message;
          }
        }, error => {
        this.disabled = false;
          this.css = {
            'margin-top': '5px',
            color: 'red',
            'font-weight': 500,
            'font-size': '13px',
          };
          this.message = 'Tên đăng nhập hoặc mật khẩu không đúng';
        }
      );
    }
  }
}
